import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { TableCell, TableHeadSearchField, TableHeadSortToggle, Typography } from '../../../../../ui-kit';
import { HeadCell, Row } from './types';
import CategoryAutocompleteSelect from './CategoryAutocompleteSelect';

interface ProductTableHeadCellProps {
    headCell: HeadCell<Row>;
    index: number;
    query: string;
    setQuery(arg: string): void;
    markupSort: string | false;
    setMarkupSort(arg: string | false): void;
    foodCostSort: string | false;
    setFoodCostSort(arg: string | false): void;
}

const ProductTableHeadCell = ({
    headCell,
    index,
    query,
    setQuery,
    markupSort,
    setMarkupSort,
    foodCostSort,
    setFoodCostSort,
}: ProductTableHeadCellProps) => {
    const { t } = useTranslation();
    let tableHeadCellContent: React.ReactNode;

    switch (headCell.id) {
        case 'name':
            tableHeadCellContent = (
                <TableHeadSearchField
                    margin='dense'
                    fullWidth
                    value={query}
                    onChange={setQuery}
                    placeholder={t('Search item')}
                />
            );
            break;
        case 'category':
            tableHeadCellContent = <CategoryAutocompleteSelect />;
            break;
        case 'markup':
            tableHeadCellContent = (
                <Box display='flex' justifyContent={headCell.align} alignItems='center'>
                    <TableHeadSortToggle sort={markupSort} setSort={setMarkupSort} />
                    <Box mr={0.5} />
                    <Typography
                        uppercase
                        color='textSecondary'
                        variant='caption'
                    >
                        {t(...headCell.label)}
                    </Typography>
                </Box>
            );
            break;
        case 'foodCost':
            tableHeadCellContent = (
                <Box display='flex' justifyContent={headCell.align} alignItems='center'>
                    <TableHeadSortToggle sort={foodCostSort} setSort={setFoodCostSort} />
                    <Box mr={0.5} />
                    <Typography
                        align={headCell.align}
                        uppercase
                        color='textSecondary'
                        variant='caption'
                    >
                        {t(...headCell.label)}
                    </Typography>
                </Box>
            );
            break;
        default:
            tableHeadCellContent = (
                <Typography
                    align={headCell.align}
                    uppercase
                    color='textSecondary'
                    variant='caption'
                >
                    {t(...headCell.label)}
                </Typography>
            );
            break;
    }
    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={index === 0}
            padding='none'
        >
            <Box mx={2}>
                {tableHeadCellContent}
            </Box>
        </TableCell>
    );
};

export default ProductTableHeadCell;
